import React, { useEffect, useState } from "react";
import { Input, FormGroup, Label, Button, Table, Spinner } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";

import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineDelete } from "react-icons/ai";
import {
  getAllPlaces, getGalleryList
} from "../../redux/actions/indexActions";

import { toast } from "react-toastify";
const EditGallery = () => {
  const [image, setImages] = useState([]);
  const [galleryImages, getimages] = useState([]);
  const [imgs, setimg] = useState([]);

  const { id } = useParams();
  const [formData, setFormData] = useState({
    place_id: "",
    caption: "",
    type: "",
    video_url: "",
    status: 1,
    thumbnail: "",
    // imgs:[],
  });
  const [errors, setErrors] = useState({});

  const {
    AuthReducer: { auth },
    indexReducer: { places, loading }
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "thumbnail") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    }
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  useEffect(() => {
    dispatch(getAllPlaces(auth.token));
  }, [auth]);

  const handleSubmit = () => {
    const form = new FormData();

    image.forEach((file) => {
      form.append('images', file);
    });

    for (const key in formData) {
      if (key !== 'thumbnail') {
        form.append(key, formData[key]);
      }
    }

    // Debugging: Check form data
    for (const pair of form.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`);
    }

    axios
      .put(`/api/admin/v1/update-gallery/${id}`, form, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data?.message);
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err.response.data);
        setErrors(err.response.data);
      });
  };


  useEffect(() => {
    axios(`/api/admin/v1/edit-gallery/${id}`, {
      headers: {
        Authorization: `Bearer ${auth?.token}`,
      },
    })
      .then((res) => {
        console.log(res.data, 'data');
        setFormData({
          place_id: res.data?.gallery?.place_id,
          caption: res.data?.gallery?.caption,
          type: res.data?.gallery?.type,
          video_url: res.data?.gallery?.video_url,
          status: res.data?.gallery?.status,
          // imgs: res.data?.gallery?.gallery_images,
        });
        setimg(
          res.data?.gallery?.gallery_images,);
      })
      .catch((err) => console.log(err));
  }, [auth]);

  const handleImageChange = (event) => {
    const files = event.target.files;
    if (files.length > 0) {
      // Convert the FileList to an array of file objects
      const fileList = Array.from(files);

      // Update the state with the array of file objects
      setImages(fileList);
    }
  };
  const handleDelimageImage = (id) => {
    if (window.confirm("Are You Sure You Want To Delete This Gallery image.")) {
      axios
        .delete(`/api/admin/v1/gallery-image-delete/${id}`, {
          headers: {
            Authorization: `Bearer ${auth?.token}`,
          },
        })
        .then((res) => {
          toast.success(res.data.message);
          // dispatch(getGalleryList(auth.token));
          window.location.reload();

        })
        .catch((err) => toast.error("Somthing Went Wrong"));
    }
  };

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h4 className="text-white">Edit Gallery</h4>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Place <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.place_id}
                type="select"
                name="place_id"
                onChange={inputHandler}
                disabled={false}
              >
                <option value="">Select</option>
                {places?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.place_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.place_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>caption <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.caption)}
                value={formData?.caption}
                name="caption"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.caption} </span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label className="text-black">Type</Label>
              <Input
                value={formData?.type}
                type="select"
                name="type"
                onChange={inputHandler}
              >
                <option>Select Type</option>
                <option value="1">Image</option>
                <option value="2">Video</option>
              </Input>
              <span className="d-block text-danger"> {errors?.type} </span>
            </FormGroup>
          </div>

          {formData.type == "2" ? (
            <div className="col-md-4 offset-md-1">
              <FormGroup>
                <Label className="text-black">Video URL</Label>
                <Input
                  value={formData?.video_url}
                  invalid={Boolean(errors?.video_url)}
                  name="video_url"
                  onChange={inputHandler}
                />
                <span className="d-block text-danger">{errors?.video_url}</span>
              </FormGroup>
            </div>
          ) : null}

          {formData.type == "1" ? (
            <div className="col-md-4 offset-md-1">
              <FormGroup>
                <Label>Upload Thumbnail</Label>
                <Input
                  // type="file"
                  // invalid={Boolean(errors?.thumbnail)}
                  // name="thumbnail"
                  // onChange={(e) =>
                  //   setFormData((prev) => ({
                  //     ...prev,
                  //     [e.target.name]: e.target.files[0],
                  //   }))
                  // }
                  type="file"
                  invalid={Boolean(errors?.thumbnail)}
                  name="thumbnail"
                  multiple
                  onChange={handleImageChange}
                />
                <span className="d-block text-danger">{errors?.thumbnail}</span>
              </FormGroup>
            </div>
          ) : null}

          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input
                type="switch"
                checked={formData?.status}
                onChange={inputHandler}
                name="status"
              />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
          <Table hover responsive className="mt-2">
            <thead>
              <tr>
                <th>SL. No.</th>
                <th>Image</th>

                <th>Action</th>
              </tr>
            </thead>
            {loading ? (
              <Spinner />
            ) : (
              <tbody>
                {imgs?.map?.((items, index) => {
                  return (
                    <tr>
                      <th scope="row">{index + 1}</th>
                      <td>
                        <img
                          src={`https://india-tourism.s3.ap-south-1.amazonaws.com/${items?.gallery_image}`}
                          height={45}
                          width={45}
                        />
                      </td>

                      <td>
                        <span className="text-muted" title="Images cannot be deleted">
                          <AiOutlineDelete
                            size={22}
                            className="text-secondary"
                            style={{ cursor: 'not-allowed', opacity: 0.5 }}
                          />
                        </span>
                      </td>
                      <td></td>
                    </tr>
                  );
                })}
              </tbody>
            )}
          </Table>
        </div>
      </div>
    </div>

  );


};

export default EditGallery;
